import { createSelector } from '@reduxjs/toolkit';
import getConfiguration from 'store/app/selector/getConfiguration';
import { ReactAppConfiguration } from 'store/app/types';
import { Store } from 'store/index';

const getConfigurationByKey = (key: string) => createSelector(getConfiguration, (config) => config?.[key]);

export default getConfigurationByKey;

export const getConfigurationReact = createSelector(
  getConfigurationByKey('react_app'),
  (config) => config as ReactAppConfiguration | undefined,
);

export const getReactConfigurationByKey = (key: keyof ReactAppConfiguration) =>
  createSelector(getConfigurationReact, (config) => config?.[key]);

export const getIsGettySearchEnabled = createSelector(getConfigurationByKey('isGettySearchEnabled'), Boolean);

export const getIsStudioSelectionCategory = createSelector(
  getReactConfigurationByKey('useReactProductPagesForCategories'),
  (_: Store, categoryId: number) => categoryId,
  (useReactProductPagesForCategories, categoryId) =>
    !!(categoryId && useReactProductPagesForCategories?.includes(categoryId)),
);
